const Util = {};
import axios from "axios";
import qs from "qs";
axios.defaults.withCredentials = true;

//import { countries } from '../util/countries.js';
Util.install = function (Vue) {
    Vue.prototype.$util = {
        //获取列表
        apiUrl: function (url) {
            if (url.substr(0, 1) == "/") url = url.substr(1);
            if (location.host.indexOf("101.200.175.63") !== -1)
                return "http://101.200.175.63:878/" + url;
            return "http://localhost:89/" + url;
        },

        //ajax请求
        axios: {
            get: function (url, data, callback) {
                Vue.prototype.bus.$emit('loading', true);
                axios
                    .get(
                        url,
                        {
                            params: data
                        },
                        {
                            onUploadProgress: progressEvent => {
                                //console.log(progressEvent);
                            },
                            onDownloadProgress: progressEvent => {
                                //console.log(progressEvent);
                                //Vue.prototype.bus.$emit('loading', progressEvent.loaded / progressEvent.loaded * 100);
                            }
                        }
                    )
                    .then(result => {
                        Vue.prototype.bus.$emit('loading');

                        if (result.data.status == 0) {
                            Vue.prototype.bus.$emit("login");
                        }

                        callback(result.data);
                    })
                    .catch(error => {
                        Vue.prototype.bus.$emit("loading");
                        console.log(error);
                    });
            },
            post: function (url, data, callback) {
                Vue.prototype.bus.$emit("loading", true);
                axios
                    .post(url, qs.stringify(data))
                    .then(result => {
                        Vue.prototype.bus.$emit("loading");

                        if (result.data.status == 0) {
                            Vue.prototype.bus.$emit("login");
                        }

                        callback(result.data);
                    })
                    .catch(error => {
                        Vue.prototype.bus.$emit("loading");
                        console.log(error);
                    });
            }
        },

        //加载国家地图json数据、国家基本信息
        loadCountry: function (country, callback) {
            this.axios.get(
                this.apiUrl("/country/map/" + country),
                null,
                function (data) {
                    //console.log(data)
                    //$this.bus.$emit("loading");
                    callback(data);
                }
            );
        },

        browser() {
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf('Opera') > -1) {
                return 'opera';
            } else if (userAgent.indexOf('Firefox') > -1) {
                return 'firefox';
            } else if (userAgent.indexOf('Chrome') > -1) {
                return 'chrome';
            } else if (userAgent.indexOf('Safari') > -1) {
                return 'Safari'
            } else if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1) {
                return 'ie';
            }
        },

        //获取某个国家的坐标
        getGisByCountry: function (country) {
            return countries[country] == undefined ? false : countries[country];
        },

        //将两个颜色分成多个阶梯块
        gradientColor: function (startColor, endColor, step) {
            var startRGB = this.colorRgb(startColor); //转换为rgb数组模式
            var startR = startRGB[0];
            var startG = startRGB[1];
            var startB = startRGB[2];
            var endRGB = this.colorRgb(endColor);
            var endR = endRGB[0];
            var endG = endRGB[1];
            var endB = endRGB[2];
            var sR = (endR - startR) / step; //总差值
            var sG = (endG - startG) / step;
            var sB = (endB - startB) / step;
            var colorArr = [];
            for (var i = 0; i < step; i++) {
                //计算每一步的hex值
                var hex = this.colorHex(
                    "rgb(" +
                    parseInt(sR * i + startR) +
                    "," +
                    parseInt(sG * i + startG) +
                    "," +
                    parseInt(sB * i + startB) +
                    ")"
                );
                colorArr.push(hex);
            }
            return colorArr;
        },
        // 将hex表示方式转换为rgb表示方式(这里返回rgb数组模式)
        colorRgb: function (sColor) {
            var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            sColor = sColor.toLowerCase();
            if (sColor && reg.test(sColor)) {
                if (sColor.length === 4) {
                    var sColorNew = "#";
                    for (var i = 1; i < 4; i += 1) {
                        sColorNew += sColor
                            .slice(i, i + 1)
                            .concat(sColor.slice(i, i + 1));
                    }
                    sColor = sColorNew;
                }
                //处理六位的颜色值
                var sColorChange = [];
                for (var i = 1; i < 7; i += 2) {
                    sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
                }
                return sColorChange;
            } else {
                return sColor;
            }
        },
        // 将rgb表示方式转换为hex表示方式
        colorHex: function (rgb) {
            var _this = rgb;
            var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            if (/^(rgb|RGB)/.test(_this)) {
                var aColor = _this.replace(/(?:(|)|rgb|RGB)*/g, "").split(",");
                var strHex = "#";
                for (var i = 0; i < aColor.length; i++) {
                    var hex = Number(aColor[i]).toString(16);
                    hex = hex < 10 ? 0 + "" + hex : hex; // 保证每个rgb的值为2位
                    if (hex === "0") {
                        hex += hex;
                    }
                    strHex += hex;
                }
                if (strHex.length !== 7) {
                    strHex = _this;
                }
                return strHex;
            } else if (reg.test(_this)) {
                var aNum = _this.replace(/#/, "").split("");
                if (aNum.length === 6) {
                    return _this;
                } else if (aNum.length === 3) {
                    var numHex = "#";
                    for (var i = 0; i < aNum.length; i += 1) {
                        numHex += aNum[i] + aNum[i];
                    }
                    return numHex;
                }
            } else {
                return _this;
            }
        }
    };
};
export default Util;
